"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroPrincipal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508450/img/hero_consulting_strategy.png)]" style={{
      backgroundAttachment: "fixed"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-dark-background/60" aria-hidden="true" />

      {}
      <div className={`relative z-10 text-center px-4 max-w-4xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-6 leading-tight">Impulsamos tu crecimiento con soluciones estratégicas</h1>

        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Gestión comercial, marketing y e-commerce como tu departamento externalizado
        </p>

        <Link to="/ContactPage">
          <Button size="lg" className="transition-all duration-[120ms] ease-in-out hover:-translate-y-0.5 hover:shadow-medium text-base md:text-lg px-8 py-6">
            Solicita una consulta gratuita
          </Button>
        </Link>
      </div>
    </section>;
}